import { IPurchasableVariant } from "@smartrr/shared/entities/PurchasableVariant";
import React from "react";

import { RedeemVariantOTPConfirmation } from "./OTPConfirmation";
import { RedeemVariantOTPConfirmed } from "./OTPConfirmed";
import { RedeemVariantModalProps } from "..";
import { LoyaltyStoreAccess } from "../../../../store";

export interface RedeemVariantOTPProps extends RedeemVariantModalProps {
  shopifyVariant: IPurchasableVariant | undefined;
  closeVariantModal: () => void;
}
export const RedeemVariantOTP = ({ variant, shopifyVariant, closeVariantModal }: RedeemVariantOTPProps) => {
  const discountCode = LoyaltyStoreAccess.useDiscountCode();
  const redeemedVariants = LoyaltyStoreAccess.useRedeemedVariants();
  const foundRedeemedVariant = redeemedVariants.find(redeemedVariant => redeemedVariant.id === variant.id);
  const newDiscountCode = foundRedeemedVariant?.discountCode ?? discountCode;

  return (
    <React.Fragment>
      {foundRedeemedVariant?.discountCode ? (
        <RedeemVariantOTPConfirmed
          variant={variant}
          shopifyVariant={shopifyVariant}
          closeVariantModal={closeVariantModal}
          discountCode={newDiscountCode}
        />
      ) : (
        <RedeemVariantOTPConfirmation
          variant={variant}
          shopifyVariant={shopifyVariant}
          closeVariantModal={closeVariantModal}
        />
      )}
    </React.Fragment>
  );
};
